// src: "https://jarvis-comms-scheduler-widget.surge.sh/img/logo.png",
// https://schedule.staging.jarvisanalytics.com/frame/DECA?map=%7B%22visible%22%3Atrue%2C%22pinColor%22%3A%22%23000000%22%2C%22center%22%3A%7B%22lat%22%3A29.664889%2C%22lng%22%3A-95.205737%7D%7D

export default {
  data() {
    return {
      config: {
        title: "Book an Appointment",
        token: process.env.VUE_APP_API_TOKEN || null,
        endpoint: process.env.VUE_APP_GRAPHQL_ENDPOINT || null,
        locationId: process.env.VUE_APP_LOCATION_ID || null,
        companyId: process.env.VUE_APP_COMPANY_ID || null,
        iframeMode: false,
        showLogo: 1,
        showPhoneNumber: true,
        useDatePicker: false,
        logo: {
          src: null,
          width: 189,
          height: 39,
        },
        colors: {
          bodyBackground: "#F3F4F6",
          headerBackground: "#FFFFFF",
          headerColor: "#212127",
          footerBackground: "#FFFFFF",
          containerBackground: "#FFFFFF",
          availabilityBackground: "#F9FAFB",
          availabilityPaginationBackground: "#111827",
          availabilityPaginationColor: "#FFFFFF",
          availabilityColumnHeaderBackground: "#111827",
          availabilityColumnHeaderColor: "#FFFFFF",
          nearestCardBackground: "#FFFFFF",
          nearestCardBorderColor: "#D1D5DB",
          nearestCardColumnHeaderBackground: "#111827",
          nearestCardColumnHeaderColor: "#FFFFFF",
          nearestCardTitleColor: "#212127",
          nearestCardSubtitleColor: "#9CA3AF",
          activeNavItemBackground: "#51B44F",
          activeNavItemColor: "#FFFFFF",
          inactiveNavItemBackground: "#9CA3AF",
          inactiveNavItemColor: "#FFFFFF",
          navItemColor: "#212127",
          primaryOptionColor: "#51B44F",
          secondaryOptionColor: "#D4F3BB",
          primaryButtonBackground: "#51B44F",
          primaryButtonBorderColor: "#51B44F",
          primaryButtonColor: "#FFFFFF",
          secondaryButtonBackground: "transparent",
          secondaryButtonBorderColor: "#212127",
          secondaryButtonColor: "#212127",
          samedayCardBackground: "#FFFFFF",
          samedayCardBorderColor: "#E5E7EB",
          samedayCardDividerColor: "#212127",
          samedayCardTitleColor: "#212127",
          samedayCardSubtitlesColor: "#9CA3AF",
          samedayCardServiceTitleColor: "#212127",
        },
        samedayTitle: "Same-Day Appointment",
        sameday: process.env.VUE_APP_SAMEDAY || false,
        samedayOpen: false,
        includeServices: null,
        override: null,
        referrer: null,
        reservedWithGoogle: false,
        rwg_token: null,
        modalMode: false,
        // modalMode: true,
        // map: null,
        // map: {
        //   visible: true,
        //   pinColor: "#000000",
        // },
        // override: {
        //   patient_type: "new",
        //   age_type: "adult",
        //   service_id: "17",
        //   referrer: "https://jarvis-scheduler-config.surge.sh/guide/#initialize",
        // },
      },
    };
  },
};
